import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DocumentManagementService} from '../../services/document-management.service';
import {ViewManagerService} from '../../../core/services/view-manager-service';
import {Observable} from 'rxjs';
import {DocumentManagementStoreService} from '../../services/document-management-store.service';
import {ElaborationDocument} from '../../models/elaboration-doc';
import {ElaborationDocumentFilter} from '../../models/elaboration-doc-filter';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import { Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'main [app-document-management-dettaglio]',
  templateUrl: './document-management-dettaglio.component.html',
  styleUrls: ['./document-management-dettaglio.component.css'],
  host: {'[attr.id]': '\'content\''},
})
export class DocumentManagementDettaglioComponent implements OnInit {

  private id: string;
  elaboration$: Observable<ElaborationDocument>;
  filters: ElaborationDocumentFilter[] = [];
  isHandsetSizeScreen
  constructor(
    private activatedRoute: ActivatedRoute,
    private documentManagementService: DocumentManagementService,
    private viewManagerService: ViewManagerService,
    private documentManagementStoreService: DocumentManagementStoreService,
    private responsive: ResponsiveService
  ) {
    this.activatedRoute.params.subscribe(val =>{
      this.id = this.activatedRoute.snapshot.paramMap.get('id');
      this.documentManagementService.getElaborationDocument$(this.id).subscribe(res => this.documentManagementStoreService.setElaboration(res));

      this.elaboration$ = this.documentManagementStoreService.elaboration$;
      this.viewManagerService.svuotaMenu();
    })


  }

  ngOnInit() {
    this.responsive.checkScreenSizeDynamic([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium
    ]).subscribe(
      state => this.isHandsetSizeScreen = state.matches
    )
  }



}
